import { useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { createUseStyles } from 'react-jss'

import { useDropzone } from 'react-dropzone'
import { FileAddFilled, FileZipFilled } from '@ant-design/icons'
import { dropZone as dropZoneStyles } from '../../../theme/shared-styles'

const useStyles = createUseStyles(() => ({
  ...dropZoneStyles,
}))

export default function ReportUpload({
  onUpload = () => {}
}) {
  const styles = useStyles()

  const onDrop = useCallback(
    acceptedFiles => {
      if (!onUpload) return

      onUpload(acceptedFiles)
    },
    [onUpload],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple: true,
    onDrop,
    disabled: false,
  })

  const dragAndDropMessage =
    'Drag and drop a PDF or click to select the file from your file browser'
  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...getRootProps({
        className: classnames(
          styles.dropZone,
          isDragActive && styles.activeDropZone,
        ),
      })}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <input {...getInputProps()} />
      {isDragActive ? (
        <>
          <p>Drop the file here ...</p>
          <FileAddFilled />
        </>
      ) : (
        <>
          <p>{dragAndDropMessage}</p>
          <FileZipFilled />
        </>
      )}
    </div>
  )
}

ReportUpload.propTypes = {
  onUpload: PropTypes.func,
  manufacturer: PropTypes.string,
}
